/* IE 11 does not support Object.assign but webpacks dynamic module
 * loading, which is inserted after babel-loader has run, needs it.
 */
import 'core-js/es';

// Use what-input to track input method
import 'what-input';

// eslint-disable-next-line no-unused-vars
import Modernizr from 'modernizr';

import throttle from 'lodash.throttle';

import NProgress from 'nprogress';

// Polyfill smoothscroll
import SmoothScroll from 'smoothscroll-polyfill';

// smoothscroll
import SmoothScrolling from 'smooth-scroll';

import objectFitImages from 'object-fit-images';

// Shims
import 'formdata-polyfill';
import './shims/closest';
import './shims/custom-event';
import forEach from './dom/forEach';

// refresh waypoints on browser resize event
window.addEventListener('resize', throttle(window.Waypoint.refreshAll, 500), false);

SmoothScroll.polyfill();

NProgress.configure({ showSpinner: false });

window.addEventListener('load', () => {
  NProgress.done();
});

document.addEventListener('DOMContentLoaded', () => {
  NProgress.start();
});

// eslint-disable-next-line no-unused-vars
const scroll = new SmoothScrolling('a[href*="#"]', {
  speed: 100,
  header: '.o-header'
});

// all links with target="_blank" attribute should hav an attribute rel="noopener". This has performance and security reasons https://developers.google.com/web/tools/lighthouse/audits/noopener
forEach(document.querySelectorAll("[target='_blank']"), (index, link) => {
  link.setAttribute('rel', 'noopener');
});

// polyfill for object-fit: cover
objectFitImages();
